import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { registerSW } from 'virtual:pwa-register'
import { LucideProvider } from 'lucide-react'

// Register service worker for PWA support (handled by Vite PWA plugin)
if (import.meta.env.PROD) {
  registerSW({
    onNeedRefresh() {
      console.log('New content available, please refresh.')
    },
    onOfflineReady() {
      console.log('App ready to work offline.')
    },
  })
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found. Check your index.html file.')
}

createRoot(rootElement).render(
  <StrictMode>
    {/* Design system icon weight: every Lucide glyph draws at 2.75 */}
    <LucideProvider strokeWidth={2.75}>
      <App />
    </LucideProvider>
  </StrictMode>
)
